import { FC, useMemo } from 'react';
import { useFATCAFormState } from '../../../utils/useFATCAFormState';
import { FATCACheckboxEntry } from '../../reusable/FATCACheckboxEntry/FATCACheckboxEntry';
import { css } from '@bts-web/utils-style-engine';
import { ButtonBase } from '../../../../common';
import { FATCATranslations } from '../../../utils/getFATCATranslations';
import { USAInfoModal } from '../../reusable/USAInfoModal/USAInfoModal';
import { mockVariablesForValues } from '../../../actions/mockVariablesForValues';
import { useModalDrawerContext } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { RegularInfo } from '../../../../common/svgIcons';

const FATCATaxationOptionsScreen: FC<{
  fatcaFormState: ReturnType<typeof useFATCAFormState>;
  translations: FATCATranslations;
}> = ({ fatcaFormState, translations }) => {
  const { showModal } = useModalDrawerContext();

  const {
    taxationOptions,
    currentTaxationOptions,
    setCurrentTaxationOptions,
    onNextStep,
    loading,
  } = fatcaFormState;

  if (!taxationOptions) {
    return null;
  }

  const usaTriggerButton = useMemo(() => {
    return (
      <ButtonBase onClick={() => showModal(USAInfoModal)}>
        <RegularInfo size={24} />
      </ButtonBase>
    );
  }, []);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'medium',
      })}
    >
      <ul
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'small',
        })}
      >
        {taxationOptions.map((option) => {
          const checked = currentTaxationOptions.includes(option.value);

          return (
            <li key={option.value}>
              <FATCACheckboxEntry
                label={option.label}
                checked={checked}
                onChange={() => {
                  if (checked) {
                    setCurrentTaxationOptions((prev) =>
                      prev.filter((item) => item !== option.value),
                    );

                    return;
                  } else {
                    setCurrentTaxationOptions((prev) => [
                      ...prev,
                      option.value,
                    ]);
                  }
                }}
                name={option.value}
                additionalElements={
                  option.value.includes(mockVariablesForValues.SURELY_NOT_US)
                    ? usaTriggerButton
                    : undefined
                }
              />
            </li>
          );
        })}
      </ul>
      <ButtonBase
        visual="primary"
        onClick={onNextStep}
        disabled={loading || currentTaxationOptions.length === 0}
        fullWidth
      >
        {translations.continue}
      </ButtonBase>
    </div>
  );
};

export { FATCATaxationOptionsScreen };
